import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { BgWhite, TextGray } from "../Theme";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import MyValuesCompetencis from '../Profile/ValuesandCompetencies';
import { useDispatch, useSelector } from "react-redux";
import ModalTermsAndPolicy from '../../components/Modal/ModalTermsandPolicy';

const Footer = ({ publicPage, ...props }) => {
    const history = useHistory();
    const nie_details = useSelector(state => state.termsconditionsReducer.nie_details);
    const profile_details = useSelector(state => state.termsconditionsReducer.profile_details);
    const [content, setContent] = useState({
        modal: false,
        content: '',
        header: ''
    });
    const handlePopup = (type) => {
        if (type == 'nie') {
            setContent({
                modal: true,
                content: nie_details.Policies,
                header: nie_details.DisplayLabel
            })
        }
        else {
            setContent({
                modal: true,
                content: profile_details.Policies,
                header: profile_details.DisplayLabel
            })
        }
 
    }
    return (<>
        {/* {window.location.pathname == "/digitalportfolio2/" || window.location.pathname == "/" ?
            <MyValuesCompetencis /> : <></>} */}
        <div className="px-6 md:px-10 flex flex-col backGroundColor py-6">
            {/* <hr className="mb-5 border-gray-100" /> */}
            <div className="grid grid-cols-1 sm:grid-cols-2 justify-between">
                <div className="text-center sm:text-left">
                    <p className="text-base blackColor font-semibold">
                        &copy; {new Date().getFullYear()} National Institute of Education Singapore. All rights reserved.
                    </p>
                    <span class="text-gray-600 footerVersionText">{process.env.REACT_APP_DP4_VERSION}</span>
                </div>
                <div className="flex gap-5 justify-center sm:justify-end items-center">
                    {/* <Link className="nav-navigate">
                        <TextGray className="hover:underline blackColor font-semibold" onClick={() => window.open("https://www.ntu.edu.sg/nie/privacy-policy", "_self")}>Privacy Policy</TextGray>
                    </Link>
                    <Link className="nav-navigate">
                        <TextGray className="hover:underline blackColor font-semibold" onClick={() => window.open("https://www.ntu.edu.sg/nie/terms-of-use", "_self")}>Terms of Use</TextGray>
                    </Link> */}
                    {/* <Link className="nav-navigate"> */}
                    {profile_details?.DisplayLabel &&
                        <TextGray className="hover:underline blackColor font-semibold cursor-pointer" onClick={() => handlePopup('policy')}>{profile_details?.DisplayLabel}</TextGray>
                    }
                    {/* </Link> */}
                    {/* <Link className="nav-navigate"> */}
                    {nie_details?.DisplayLabel &&
                        <TextGray className="hover:underline blackColor font-semibold cursor-pointer" onClick={() => handlePopup('nie')}>{nie_details?.DisplayLabel}</TextGray>
                    }
                    {/* </Link> */}
                </div>
            </div>
        </div>
        {content.modal &&
            <ModalTermsAndPolicy
                showPolicyModal={content?.modal}
                PolicyContent={content}
                setShowPolicyModal={() => setContent({
                    content: '',
                    modal: false,
                    header: ''
                })}
            />}
    </>
    )

}

export default Footer
